import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../../../../modules/commons/Button";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../../modules/SimpleInput";
import { ACTIVITY_TYPE } from "../../../../../common/Constants";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";

class MutasiDetailNoQrTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: {
        page: 1,
        limit: 5,
        totalData: 0,
      },
    };
    this.tableColumns = [
      {
        name: "",
        label: "No",
        options: {
          customBodyRender: (value, tableMeta) => {
              return <>{tableMeta.rowIndex + 1}</>;
          },
          sort: false,
        },
      },
      {
        name: "partCode",
        label: "Kode Part*",
        options: {
          sort: false,
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.part[rowIndex];
            if (row.saved) {
              return (
                <p
                  style={{
                    color: row.status === "REJECTED" ? "red" : "inherit",
                  }}
                >
                  {
                    // jika val object (mis. {label, value, ...}), tampilkan value/label
                    typeof val === "object"
                      ? val?.value || val?.label || "-"
                      : val || "-"
                  }
                </p>
              );
            } else {
              // tampilkan dropdown jika belum saved
              return (
                <SimpleDDL
                  id="input_text_kode_part"
                  name="partCode"
                  box="search"
                  isClearable
                  containerclassname="margin-bottom-none width width-250px"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "relative",
                      fontFamily:
                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                    }),
                  }}
                  readOnly={!this.props.mutasiKeluarTab}
                  options={this.props.state.partOptions || []}
                  value={val}
                  onChange={(value) =>
                    this.handlePartChange(rowIndex, value, "code")
                  }
                />
              );
            }
          },
          setCellProps: () => ({
            style: { width: "100px" },
          }),
        },
      },
      {
        name: "partName",
        label: "Nama Part*",
        options: {
          sort: false,
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.part[rowIndex];
            if (row.saved) {
              return (
                <p
                  style={{
                    color: row.status === "REJECTED" ? "red" : "inherit",
                  }}
                >
                  {val || "-"}
                </p>
              );
            } else {
              return (
                <SimpleDDL
                  id="input_text_nama_part"
                  name="partName"
                  box="search"
                  isClearable
                  readOnly={!this.props.mutasiKeluarTab}
                  containerclassname="margin-bottom-none width width-250px"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "relative",
                      fontFamily:
                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                    }),
                  }}
                  options={this.props.state.partOptions || []}
                  getOptionLabel={(opt) => opt.name}
                  getOptionValue={(opt) => opt.name}
                  value={
                    val
                      ? this.props.state.partOptions.find(
                          (opt) => opt.name === val,
                        ) || null
                      : null
                  }
                  onChange={(value) =>
                    this.handlePartChange(rowIndex, value, "name")
                  }
                />
              );
            }
          },
        },
      },
      {
        name: "partCategory",
        label: "Kategori",
        options: {
          sort: false,
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.part[rowIndex];
            if (row.saved) {
              return (
                <p
                  style={{
                    color: row.status === "REJECTED" ? "red" : "inherit",
                  }}
                >
                  {val || "-"}
                </p>
              );
            } else {
              return (
                <SimpleInput
                  id="input_text_part_category"
                  name="partCategory"
                  readOnly={true}
                  containerclassname="margin-bottom-none width width-250px"
                  value={val}
                />
              );
            }
          },
        },
      },
      {
        name: "qty",
        label: "Quantity*",
        options: {
          sort: false,
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.part[rowIndex];
            if (row.saved) {
              return (
                <p
                  style={{
                    color: row.status === "REJECTED" ? "red" : "inherit",
                  }}
                >
                  {val ?? "-"}
                </p>
              );
            } else {
              return (
                <SimpleInput
                  id={`qty-${rowIndex}`}
                  name="qty"
                  readOnly={!this.props.mutasiKeluarTab}
                  box="onlyNumber"
                  containerclassname="margin-bottom-none width width-150px"
                  value={val}
                  onChange={({ target }) =>
                    this.handleChangeQty(rowIndex, target.value)
                  }
                />
              );
            }
          },
        },
      },
      {
        name: "satuan",
        label: "Satuan",
        options: {
          sort: false,
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.part[rowIndex];
            if (row.saved) {
              return (
                <p
                  style={{
                    color: row.status === "REJECTED" ? "red" : "inherit",
                  }}
                >
                  {val || "-"}
                </p>
              );
            } else {
              return (
                <SimpleInput
                  id="input_text_part_satuan"
                  name="satuan"
                  readOnly={true}
                  containerclassname="margin-bottom-none width width-150px"
                  value={val}
                />
              );
            }
          },
        },
      },
    ];

    if (this.props.mutasiKeluarTab) {
      if (this.props.buttonType !== "delete") {
        this.tableColumns.push({
          name: "saved",
          label: "Aksi",
          options: {
            customBodyRender: (val, { rowIndex }) => {
              return this.addDetailButton(val, rowIndex);
            },
            setCellProps: () => ({
              style: { width: "5%" },
            }),
          },
        });
      }
    } else {
      this.tableColumns.splice(5, 0, {
        name: "receivedqty",
        label: "Quantity Terima*",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.part[rowIndex];
            if (row.saved) {
              return (
                <p
                  style={{
                    color: row.status === "REJECTED" ? "red" : "inherit",
                  }}
                >
                  {val === null || val === undefined || val === "" ? "-" : val}
                </p>
              );
            } else {
              return (
                <SimpleInput
                  id={`receivedqty-${rowIndex}`}
                  name="receivedqty"
                  box="onlyNumber"
                  containerclassname="margin-bottom-none width width-150px"
                  value={val}
                  onChange={({ target }) =>
                    this.handleChangeReceivedQty(rowIndex, target.value)
                  }
                />
              );
            }
          },
          setCellProps: () => ({
            style: { width: "100px" },
          }),
        },
      });
      this.tableColumns.push({
        name: "saved",
        label: "Aksi",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            return this.addDetailButton(val, rowIndex);
          },
          setCellProps: () => ({
            style: { width: "5%" },
          }),
        },
      });
    }
  }

  handlePartChange = (rowIndex, selected, type) => {
    if (!selected) {
      this.props.onSetState((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          part: prev.data.part.map((row, idx) =>
            idx === rowIndex
              ? {
                  ...row,
                  partCode: null,
                  partName: "",
                  partCategory: "",
                  satuan: "",
                }
              : row,
          ),
        },
      }));
      return;
    }

    const found =
      this.props.state.partOptions.find(
        (opt) =>
          (type === "code" && opt.value === selected.value) ||
          (type === "name" && opt.name === selected.name),
      ) || {};

    this.props.onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        part: prev.data.part.map((row, idx) =>
          idx === rowIndex
            ? {
                ...row,
                partCode: {
                  label: found.label,
                  value: found.value,
                  name: found.name,
                  category: found.category,
                  satuan: found.satuan,
                },
                partName: found.name,
                partCategory: found.category,
                satuan: found.satuan,
              }
            : row,
        ),
      },
    }));
  };

  handleChangeQty = (index, value) => {
    let qty = !R.isNil(value) && !R.isEmpty(value) ? parseInt(value) : null;
    this.props.onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        part: prev.data.part.map((row, idx) =>
          idx === index ? { ...row, qty } : row,
        ),
      },
    }));
  };

  handleChangeReceivedQty = (index, value) => {
    let receivedqty =
      !R.isNil(value) && !R.isEmpty(value) ? parseInt(value) : null;
    this.props.onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        part: prev.data.part.map((row, idx) =>
          idx === index ? { ...row, receivedqty } : row,
        ),
      },
    }));
  };

  handleAdd = () => {
    const newRow = {
      id: null,
      mutationPartId: null,
      mutationId: this.props.state.data.mutationId || null,
      partCode: null,
      partName: "",
      partCategory: "",
      qty: 0,
      satuan: "",
      saved: false,
      scanned: false,
    };

    this.props.onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        part: [...prev.data.part, newRow],
      },
    }));
  };

  /** =====================
   * Save row
   * ===================== */
  handleSaveRow = (index) => {
    this.props.onSetState((prev) => {
      const newPart = [...prev.data.part];
      const current = newPart[index];

      if (!this.validDetail(current)) {
        return {
          ...prev,
          alertVisible: true,
          warningMessage:
            "Ada field data yang perlu diisi atau tidak sesuai kriteria isian. Mohon periksa kembali.",
        };
      }

      newPart[index] = { ...current, saved: !current.saved };

      return {
        ...prev,
        data: {
          ...prev.data,
          part: newPart,
        },
      };
    });
  };

  validDetail = (obj) => {
    if (!obj.partCode || !obj.partCode.value) return false;
    if (R.isNil(obj.qty) || obj.qty <= 0) return false;
    return true;
  };

  handleDeleteRow = (index) => {
    this.props.onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        part: prev.data.part.filter((_, idx) => idx !== index),
      },
    }));
  };

  addDetailButton = (val, rowIndex) => {
    const row = this.props.state.data.part[rowIndex];
    const isRejected = row.status === "REJECTED";
    const isDisabled = this.props.buttonType === "preview";

    return (
      <FlexView vAlignContent="center">
        <Button
          className="btnAct"
          onClick={() =>
            !isRejected && !isDisabled && this.handleSaveRow(rowIndex)
          }
          disabled={isRejected || isDisabled}
        >
          <span
            style={{
              backgroundColor: "transparent",
              color: isRejected || isDisabled ? "gray" : "red",
              fontSize: 20,
            }}
          >
            {!row.saved ? (
              <i className="fa fa-save" />
            ) : (
              <i className="fa fa-pencil-alt" />
            )}
          </span>
        </Button>

        {this.props.mutasiKeluarTab ? (
          <Button
            className="btnAct margin-left-15px"
            onClick={() =>
              !isRejected && !isDisabled && this.handleDeleteRow(rowIndex)
            }
            disabled={isRejected || isDisabled}
          >
            <i
              className="fa fa-trash"
              style={{
                backgroundColor: "transparent",
                color: isRejected || isDisabled ? "gray" : "red",
                fontSize: 20,
              }}
            />
          </Button>
        ) : (
          <Button
            className="btnAct margin-left-15px"
            onClick={() => !isDisabled && this.handleReject(rowIndex)}
            disabled={isDisabled}
          >
            <span
              style={{
                position: "relative",
                fontSize: 20,
                display: "inline-block",
              }}
            >
              <i
                className="fas fa-hand-paper"
                style={{
                  color: isRejected || isDisabled ? "gray" : "red",
                }}
              />
              <i
                className="fas fa-slash"
                style={{
                  position: "absolute",
                  top: 2.5,
                  left: 0,
                  color: isRejected || isDisabled ? "gray" : "red",
                }}
              />
            </span>
          </Button>
        )}
      </FlexView>
    );
  };

  handleReject = (index) => {
    this.props.onSetState((prev) => {
      const updatedPart = prev.data.part.map((row, idx) =>
        idx === index
          ? {
              ...row,
              status: row.status === "REJECTED" ? "" : "REJECTED",
            }
          : row,
      );

      return {
        ...prev,
        data: {
          ...prev.data,
          part: updatedPart,
        },
      };
    });
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { pagination } = this.state;
    let isReadOnly =
      this.props.buttonType == "preview" || this.props.buttonType == "delete";

    return (
      <>
        <FlexView
          vAlignContent="center"
          className="margin-bottom-10px"
          style={{ gap: "10px" }}
        >
          {this.props.mutasiKeluarTab && (
            <SimpleButton
              secondary={isReadOnly}
              disabled={isReadOnly}
              className={"btn btn-plus margin-left-10px"}
              icon={<i className="fa fa-plus margin-right-10px"></i>}
              text="Tambah"
              style={{ width: 145 }}
              onClick={this.handleAdd}
            />
          )}
        </FlexView>

        <SimpleDataTable
          key={`${pagination.totalData}-${pagination.page}`}
          data={this.props.state.data.part || []}
          columns={this.tableColumns}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          toCount={this.props.state.data.part?.length || 0}
          options={{
            ...defaultTableChange(
              this.handleChangePage,
              this.handleRowsPerPage,
            ),
            serverSide: false,
          }}
        />
      </>
    );
  }
}

export default MutasiDetailNoQrTab;
